import { StyledContent } from '@/components/styles'
import { Gallery } from '@/components'

const TitleContentGallery = ({ data }) => {
  const { content: htmlContent, images: imagesFromProps } = data
  const images = imagesFromProps || {}

  return (
    <>
      {htmlContent && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} dark/>
        </StyledContent.Description>
      )}

      {Object.keys(images).length > 0 && (
        <StyledContent.Gallery>
          <Gallery images={images} />
        </StyledContent.Gallery>
      )}
    </>
  )
}

export default TitleContentGallery
